import { Component } from 'react';
import * as Sentry from '@sentry/react';
import './ErrorBoundary.css';

export class ErrorBoundary extends Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, errorInfo) {
    Sentry.withScope((scope) => {
      scope.setExtras(errorInfo);
      Sentry.captureException(error);
    });
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="error-boundary" role="alert">
          <h1>Oups, une erreur est survenue</h1>
          <p>L'équipe Melodiza a été notifiée. Vous pouvez essayer de recharger.</p>
          <details>
            <summary>Détails techniques</summary>
            <pre>{this.state.error.message}</pre>
          </details>
          <button onClick={() => window.location.reload()} className="btn-primary">
            Recharger l'application
          </button>
          <button onClick={() => this.setState({ error: null })} className="btn-ghost">
            Continuer (peut être instable)
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
